import "react-phone-number-input/style.css";
import ReactPhoneNumberInput from "react-phone-number-input";
import { Input, InputRef } from "antd";
import React, { useCallback } from "react";
import noop from "lodash/noop";

import { PhoneNumberFieldProps } from "./types";

const InputComponent = React.forwardRef((props, ref) => (
  <Input
    {...props}
    ref={useCallback(
      (inputRef: InputRef) => {
        if (!inputRef || !ref) {
          return;
        }

        if (typeof ref === "function") {
          ref(inputRef.input);
        } else {
          // eslint-disable-next-line no-param-reassign
          ref.current = inputRef.input;
        }
      },
      [ref]
    )}
  />
));

const PhoneNumberField: React.FC<PhoneNumberFieldProps> = ({
  onChange = noop,
  ...props
}) => (
  <ReactPhoneNumberInput
    limitMaxLength
    addInternationalOption={false}
    defaultCountry="US"
    initialValueFormat="national"
    inputComponent={InputComponent}
    {...{ ...props, onChange }}
  />
);

export default PhoneNumberField;
